import { deepFreeze } from '../../utils/misc_utils';

export const NotificationRequestProcessStatusEnum = deepFreeze({
    PLANNED: 'PLANNED',
    FINISHED: 'FINISHED',
    CANCELED: 'CANCELED'
});